'use client'
import { NavToSrv } from '@bitechsystems/btappshell'
import {
  createStyles,
  Container,
  Group,
  ActionIcon,
  Image,
  Anchor,
  Text,
} from '@mantine/core'
import {
  IconBrandTwitter,
  IconBrandYoutube,
  IconBrandInstagram,
} from '@tabler/icons-react'

import React from 'react'
const useStyles = createStyles((theme) => ({
  footer: {
    marginTop: 120,
    borderTop: `1px solid ${
      theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
    }`,
  },

  inner: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: `${theme.spacing.md}px ${theme.spacing.md}px`,

    [theme.fn.smallerThan('sm')]: {
      flexDirection: 'column',
    },
  },

  links: {
    [theme.fn.smallerThan('sm')]: {
      marginTop: theme.spacing.lg,
      marginBottom: theme.spacing.sm,
    },
  },
}))

interface FooterCenteredProps {
  links: { link: string; label: string }[]
}

export function Footer({ links }: FooterCenteredProps) {
  const { classes } = useStyles()
  const items = (links ?? []).map((link) => (
    <Anchor<'a'>
      color='dimmed'
      key={link.label}
      href={link.link}
      sx={{ lineHeight: 1 }}
      onClick={(event) => event.preventDefault()}
      size='sm'
    >
      {link.label}
    </Anchor>
  ))

  return (
    <div className={classes.footer}>
      <div className={classes.inner}>
        <Group spacing='xs' position='left' noWrap>
          <Text align='left' inline style={{ minWidth: '200px' }}>
            © 2022 Bitech Systems
          </Text>

          <Image
            radius='md'
            fit='contain'
            height={'28px'}
            src='/res/img/simplicityicon.png'
            alt='Simplicity Logo'
          />
          <Text> Simplicity </Text>
        </Group>

        <Group className={classes.links}>{items}</Group>

        <Group spacing='xs' position='right' noWrap>
          <ActionIcon
            size='lg'
            variant='default'
            radius='xl'
            onClick={() =>
              NavToSrv(
                'https://twitter.com/Bitech_Systems',
                undefined,
                undefined,
                true
              )
            }
          >
            <IconBrandTwitter size={18} stroke={1.5} />
          </ActionIcon>
          <ActionIcon
            size='lg'
            variant='default'
            radius='xl'
            onClick={() =>
              NavToSrv(
                'https://www.youtube.com/@BitechSystems',
                undefined,
                undefined,
                true
              )
            }
          >
            <IconBrandYoutube size={18} stroke={1.5} />
          </ActionIcon>
        </Group>
      </div>
    </div>
  )
}
